// @ts-nocheck
import React from 'react';
import FormStatic from '../../common/FormStatic';
import FormTextArea from '../../common/FormTextArea';

import FormInputNumber from '../../common/FormInputNumber';
import { useTranslation } from 'react-i18next';

export interface EditNumberOfKeysFormProps {
  request: Record<string, unknown>;
  register: unknown;
  errors: Record<string, unknown>;
}

const EditNumberOfKeysForm = ({ request, register, errors }: EditNumberOfKeysFormProps) => {
  const { t } = useTranslation('requests');
  return (
    <>
      <FormStatic label="Current amount">{request.numberOfKeys}</FormStatic>
      <FormInputNumber
        register={register}
        required={true}
        pattern={'/^[0-9]+$/i'}
        error={errors.newNumberOfKeys}
        errorMessage={t('Number required')}
        name="newNumberOfKeys"
        label={t('New amount')}
        className="num"
        defaultValue={request.numberOfKeys || 0}
        autoFocus={true}
      />
      <FormTextArea
        register={register}
        required={true}
        error={errors.reason}
        errorMessage={t('Required')}
        name="reason"
        label={t('Please provide a reason...')}
        placeholder=""
      />
    </>
  );
};

export default EditNumberOfKeysForm;
